import { render, staticRenderFns } from "./bindingWechat.vue?vue&type=template&id=73e66e52&scoped=true"
import script from "./bindingWechat.vue?vue&type=script&lang=js"
export * from "./bindingWechat.vue?vue&type=script&lang=js"
import style0 from "./bindingWechat.vue?vue&type=style&index=0&id=73e66e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e66e52",
  null
  
)

export default component.exports